import type {PreferenceType} from '@mattermost/types/preferences';
import {Preferences} from 'mattermost-redux/constants';
import type {GroupChannelShowPreference} from '../types';

export function isGroupChannelShowPreference(preference: PreferenceType): preference is GroupChannelShowPreference {
    return preference.category === Preferences.CATEGORY_GROUP_CHANNEL_SHOW;
}
